import * as Factory from 'factory.ts'
import faker from 'faker'

import { EntityFactory } from '@webapp/core/utils/mocks/EntityFactory'
import {
  PDFLabelFieldMetadata,
  type PDFLabelFieldMetadataConstructor,
} from './PDFLabelFieldMetadata'
import { PDFLabelSections } from '../enums/PDFLabelSectionEnum'

export const PDFLabelFieldMetadataConstructorFactory =
  Factory.Sync.makeFactory<PDFLabelFieldMetadataConstructor>({
    fieldKey: Factory.each(() => faker.lorem.word()),
    defaultLabel: Factory.each(() => faker.lorem.words()),
    section: PDFLabelSections.PO_FIELDS,
    maxLength: 100,
    isCustomFieldLabel: false,
  })

export const PDFLabelFieldMetadataFactory = EntityFactory(
  PDFLabelFieldMetadata,
  PDFLabelFieldMetadataConstructorFactory
)
